var _a;
import { MaterialOriginType as ServerMaterialOriginType } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { MaterialOriginType as ClientMaterialOriginType } from '@features/guidbooks/types';
export var materialOriginTypeMap = createDataRecordConverter((_a = {},
    _a[ClientMaterialOriginType.Generic] = ServerMaterialOriginType.Generic,
    _a[ClientMaterialOriginType.Manufacturer] = ServerMaterialOriginType.Manufacturer,
    _a[ClientMaterialOriginType.UserDefinedProduct] = ServerMaterialOriginType.UserDefinedProduct,
    _a));
export var convertToServerMaterialOriginTypeData = function (type) {
    return materialOriginTypeMap.toServer[type];
};
export var convertToClientMaterialOriginTypeData = function (type) {
    return materialOriginTypeMap.toClient[type];
};
